module.exports = __webpack_public_path__ + "img/table-sort-asc-light.d94fa422.svg";